var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  "data-name": "Group 13449"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z",
  "data-name": "Rectangle 37"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  "data-name": "Group 9"
}, /*#__PURE__*/React.createElement("path", {
  d: "m6.473 6.473 10.944 10.944",
  "data-name": "Path 18"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.473 17.417 17.417 6.473",
  "data-name": "Path 19"
})))));
export { SvgClose as ReactComponent };
export default __webpack_public_path__ + "static/media/close.68b693834b520456cb7f02fc9986915c.svg";